import { useState } from "react";
import { motion } from "framer-motion";
import SecondSectionApp from "./SecondSectionApp";
import SecondSectionGateway from "./SecondSectionGateway";
import { CategoryButton } from "../Button/CategoryButton";
import SecondSectionServices from "./SecondSectionServices";
import SecondSectionSpotlight from "./SecondSectionSpotlight";
import SecondSectionFieldPro from "./SecondSectionFieldPro";
import SecondSectionPickleball from "./SecondSectionPickleball";
import SecondSectionLoophole from "./SecondSectionLoopHole";
import SecondSectionCapital from "./SecondSectionCaptial";

export default function SecondSection({ activeTab, setActiveTab }) {

  return (
    <>
      {/* Buttons */}
      <div className="bg-neutral-50 py-10">
        {/* Section Title */}
        <h2 className="text-center text-xl font-bold mb-4">
          Explore our categories
        </h2>

        {/* Scroll Container */}
        <div className="relative">
          <div
            className="
      flex gap-4 px-4 pb-2
      overflow-x-auto
      flex-nowrap
      snap-x snap-mandatory
      scrollbar-hide
      mx-6
      lg:justify-center
      lg:flex-wrap
      lg:overflow-visible
    "
          >
            <CategoryButton
              label="NextLoop App"
              color="bg-yellow-400"
              onClick={() => setActiveTab("nextloop")}
            />

            <CategoryButton
              label="Gateway"
              color="bg-indigo-500"
              onClick={() => setActiveTab("gateway")}
            />

            <CategoryButton
              label="Services"
              color="bg-sky-400"
              onClick={() => setActiveTab("services")}
            />

            <CategoryButton
              label="Spotlight"
              color="bg-emerald-500"
              onClick={() => setActiveTab("spotlight")}
            />

            <CategoryButton
              label="FieldPro"
              color="bg-orange-500"
              onClick={() => setActiveTab("fieldpro")}
            />

            <CategoryButton
              label="Pickleball"
              color="bg-pink-500"
              onClick={() => setActiveTab("Pickleball")}
            />

            <CategoryButton
              label="Loophole Studio"
              color="bg-purple-600"
              onClick={() => setActiveTab("loophole")}
            />

            <CategoryButton
              label="Capital"
              color="bg-amber-500"
              onClick={() => setActiveTab("capital")}
            />
          </div>
        </div>


        {/* Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
          className="py-16"
        >
          {activeTab === "nextloop" && <SecondSectionApp />}
          {activeTab === "gateway" && <SecondSectionGateway />}
          {activeTab === "services" && <SecondSectionServices />}
          {activeTab === "spotlight" && <SecondSectionSpotlight />}
          {activeTab === "fieldpro" && <SecondSectionFieldPro />}
          {activeTab === "Pickleball" && <SecondSectionPickleball />}
          {activeTab === "loophole" && <SecondSectionLoophole />}
          {activeTab === "capital" && <SecondSectionCapital />}
        </motion.div>
      </div>
    </>
  );
}
